import React, { useState, useEffect } from 'react';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import DateSelector from 'components/DateSelector/DateSelector';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import PageLink from 'components/PageLink/PageLink';
import { useHistory } from 'react-router-dom';
import http from 'app/http';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import { setContent } from 'features/content/reducer';
import styles from './UpdatePaymentPlanChangeDatePageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView, formProgression} from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const UpdatePaymentPlanChangeDate = (props: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { Model, PageData, LayoutModel } = props;
  let availableDates: Date[] = [];
  let dateFormat: string = 'dd/MM/yyyy';
  const locale = PageData?.Language;

  const [seletedDate, setselectedDate] = useState('');
  const [seletedUpdatedDate, setseletedUpdatedDate] = useState<Date>(
    Model.FormModel.SelectedFirstPaymentDate,
  );
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  function changeDate(e: any) {
    setselectedDate(e);
    setseletedUpdatedDate(e);
  }

  useEffect(() => {
    setseletedUpdatedDate(Model?.FormModel?.SelectedFirstPaymentDate);
  }, [Model?.FormModel?.SelectedFirstPaymentDate]);
  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.post(
        Model.NextUrl,
        // Convert object into string
        qs.stringify({
          'FormModel.SelectedFirstPaymentDate': seletedUpdatedDate,
          'FormModel.PlanDetailsFirstPaymentDueDateRaw': seletedUpdatedDate,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state

        // console.log(nextPagePath);
        // Add response to store
        let nextPagePath = '';
        if (!response.data.RedirectUrl) {
          nextPagePath = getPathnameFromUrl(Model?.NextUrl);

          dispatch(setContent({ [nextPagePath]: response.data }));
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        }

        // Redirect to next step path
        history.push(nextPagePath, {
          noRefresh: true,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (!isNullOrWhiteSpace(Model.MarketShortDateFormat)) {
    dateFormat = Model.MarketShortDateFormat;
  }

  (Model.PaymentDates || []).map((PaymentDate: any) => {
    let dateVal = PaymentDate.Date.substring(0, PaymentDate.Date.length - 6);
    availableDates.push(new Date(dateVal));
  });

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

    useEffect(() => {
      if (eventTracked == false) {
        var tagManagerArgs: any;
        tagManagerArgs = {
          dataLayer: {
            event: 'checkout_step',
            checkout_name: 'Payment Plan Update',
            checkout_step_number: '2',
            is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
          }
        }
        TagManager.dataLayer(tagManagerArgs);
        setEventTracked(true);
      }
    }, [eventTracked]);
  return (
    <form onSubmit={formSubmit}>
      <div className={styles.wrapper}>
        <div className={styles.section}>
          <ChangePlanHeader Headingtext={PageData?.Heading} />
          <div className="Grid Grid--gutterH Grid--white">
            <div className="Grid-cell">
              <h5 className={'u-sm-textCenter  ' + styles.Heading_h5}>
                {PageData?.DateSectionHeading}
              </h5>
            </div>
            <div className="Grid-cell u-md-size1of3 u-marginBsm">
              <label className="Form-label u-block">
                {PageData?.DateSelectionRuleDescription}
              </label>
              <label className="Form-label u-block">
                {PageData.CurrentPaymentDateLabel}
              </label>
              <span>{Model.PlanDetails.PlanDetailsFirstPaymentDueDate}</span>
              {Model.DateIsNotSelectedError && (
                <div className="text-danger" role="alert">
                  {PageData?.NoSelectedDateLabel}
                </div>
              )}
            </div>
            <div className="Grid-cell u-sm-size2of3">
              <div className={'Datepicker-wrapper' + styles.Datepicker_section}>
                <DateSelector
                  className={styles.Datepicker_input}
                  date={seletedDate}
                  placeholder={Model?.PageDataBase.DateFieldPlaceholder}
                  calendarStartDay={1}
                  onChange={(e) => changeDate(e)}
                  locale={locale}
                  includeDates={availableDates}
                  onBlur={(e)=>{formProgression(e,'UpdatePlanChangeDateForm','SelectedDate')}}
                />
              </div>
            </div>
          </div>
          <div className="Grid">
            <div className="Grid-cell">
              <div className="ButtonBar ButtonBar--spaceBetween ButtonBar--row-reverse ButtonBar-sm--spaceBetween">
                <button type="submit" className="Button">
                  {PageData.NextBtnLabel}
                </button>

                <PageLink
                  url={Model.BackUrl}
                  text={PageData.BackBtnLabel}
                  className="Button Button--gray"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UpdatePaymentPlanChangeDate;
